
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-benefit",
      function () {
        return require("private-next-pages/free-benefit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-benefit"])
      });
    }
  